import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Brain, ArrowRight, Play } from 'lucide-react';

const PersonalizedListSection = () => {
  return (
    <section className="py-5 hero-gradient">
      <div className="container">
        <div className="text-center mb-4 px-2">
          <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
            <Brain className="text-primary" size={28} />
            <h2 className="h1 fw-bold text-dark mb-0" style={{ fontSize: 'clamp(1.5rem, 4.5vw, 2.5rem)' }}>
              Get Your Personalized College List
            </h2>
          </div>
          <p className="lead text-muted" style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
            Watch how our personalized college list works and how to get yours
          </p>
        </div>

        <div className="row justify-content-center px-2 px-md-0">
          <div className="col-lg-10 col-md-11">
            <div className="card border-0 shadow-lg">
              <div className="card-body p-3 p-md-4">
                <div className="ratio ratio-16x9 mb-3 mb-md-4">
                  <iframe 
                    src="https://www.youtube.com/embed/pXH58erfx60?si=TsMsk4xz4m0zSfx4" 
                    title="How Our Personalized College List Works" 
                    allowFullScreen
                    className="rounded"
                  ></iframe>
                </div>
                
                <div className="row g-3 g-md-4 mt-2">
                  <div className="col-12 col-md-8">
                    <h3 className="h4 fw-bold text-dark mb-3" style={{ fontSize: 'clamp(1.1rem, 3.5vw, 1.5rem)' }}>How Our NEET College Predictor Works</h3>
                    <p className="text-muted mb-3 mb-md-4" style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                      Our AI-powered system analyzes your NEET rank, category, and preferences to generate a customized list of medical colleges where you have the best chances of admission. Watch the video to learn how it works!
                    </p>
                    <div className="d-flex flex-column flex-sm-row gap-2 gap-md-3">
                      <Link to="/neet-college-predictor" className="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto" style={{ minHeight: '44px' }}>
                        <Brain size={18} />
                        Get Your Predictions Now
                      </Link>
                      <Link to="/contact" className="btn btn-outline-primary d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto" style={{ minHeight: '44px' }}>
                        <ArrowRight size={18} />
                        Contact Our Experts
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-12 col-md-4">
                    <div className="card bg-primary bg-opacity-10 border-0">
                      <div className="card-body p-3 p-md-4">
                        <h4 className="h5 fw-bold text-primary mb-3" style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>What You'll Get</h4>
                        <ul className="list-unstyled mb-0">
                          <li className="d-flex align-items-center gap-2 mb-2">
                            <div className="bg-primary rounded-circle p-1 d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px"}}>
                              <Play size={12} className="text-white" />
                            </div>
                            <span style={{ fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)' }}>Medical college recommendations based on your NEET rank</span>
                          </li>
                          <li className="d-flex align-items-center gap-2 mb-2">
                            <div className="bg-primary rounded-circle p-1 d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px"}}>
                              <Play size={12} className="text-white" />
                            </div>
                            <span style={{ fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)' }}>Dream, target & safety medical colleges</span>
                          </li>
                          <li className="d-flex align-items-center gap-2 mb-2">
                            <div className="bg-primary rounded-circle p-1 d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px"}}>
                              <Play size={12} className="text-white" />
                            </div>
                            <span style={{ fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)' }}>Accurate NEET admission probability analysis</span>
                          </li>
                          <li className="d-flex align-items-center gap-2">
                            <div className="bg-primary rounded-circle p-1 d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px"}}>
                              <Play size={12} className="text-white" />
                            </div>
                            <span style={{ fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)' }}>Detailed NEET cutoff information</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalizedListSection;